import { Link } from "react-router-dom";
import { convertStringToArray } from "../../../../Utils/utils";
import { useLanguageTranslation } from "../../../../hooks/useLanguageTranslation";

const PhotoGalleryCoverCard = ({ photoGalleryItem }) => {
  const photoArray = convertStringToArray(
    photoGalleryItem.field_mulitple_photo_upload
  );

  const { getText } = useLanguageTranslation();

  return (
    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
      <div className="gallery-card">
        <div className="crd-title">
          <p className="title-txt">{photoGalleryItem.title}</p>
        </div>
        <div className="card-imgs">
          {photoArray.slice(0, 2).map((item) => (
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}${item?.file_path}`}
              alt=""
            />
          ))}
        </div>
        <div className="card-buttons">
          <Link
            // href=""
            to={`/photo-gallery-detail/${photoGalleryItem.nid}`}
            className="quick-btn"
          >
            {getText("View More", "और देखो")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PhotoGalleryCoverCard;
